// Libs
import React from "react";
import { useQueryParam, StringParam } from "use-query-params";
import ScrollMenu from "react-horizontal-scrolling-menu";

// Components
import {
  CategoryItem,
  CategoryIcon,
  CategoryLabel,
  CategoriesSliderStyle,
  Arrow
} from "./CategoriesSliderStyle";

// Static Data
import { allCategories } from "../staticCategories";

// Images
import iconChevronRight from "../../../images/icon-chevron-right.svg";
import iconChevronLeft from "../../../images/icon-chevron-left.svg";

const CategoriesSlider = ({ onClick }) => {
  const setCategory = useQueryParam("category", StringParam)[1];
  const setSubcategory = useQueryParam("subcategory", StringParam)[1];
  const setCollectionId = useQueryParam("collection_id", StringParam)[1];

  const ArrowTemplate = ({ components, className }) => {
    return <Arrow className={className}>{components}</Arrow>;
  };

  const ArrowLeft = ArrowTemplate({
    components: <img src={iconChevronLeft} alt="arrow left" />,
    className: "arrow-prev"
  });

  const ArrowRight = ArrowTemplate({
    components: <img src={iconChevronRight} alt="arrow right" />,
    className: "arrow-next"
  });

  const getAllCategories = () => {
    return allCategories().map(category => {
      return (
        <CategoryItem
          key={category.value}
          onClick={() => {
            onClick && onClick();
            setCategory(category.value);
            setSubcategory(null);
            setCollectionId(null);
          }}
        >
          <CategoryIcon>{category.icon}</CategoryIcon>
          <CategoryLabel>{category.label}</CategoryLabel>
        </CategoryItem>
      );
    });
  };

  return (
    <CategoriesSliderStyle>
      <ScrollMenu
        data={getAllCategories()}
        hideArrows={true}
        hideSingleArrow={true}
        arrowLeft={ArrowLeft}
        arrowRight={ArrowRight}
        alignCenter={false}
        clickWhenDrag={false}
        transition={0.6}
        wheel={true}
      />
    </CategoriesSliderStyle>
  );
};

export default CategoriesSlider;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/header/CategoriesSlider.js